import * as React from "react";
export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 24 24"
  >
    <defs>
      <path
        id="icons-file-plist_svg__a"
        d="M18.47 6h-2.058V4H4.059v16h12.353v-2h2.059v2c0 1.1-.927 2-2.06 2H4.06C2.926 22 2 21.1 2 20V4c0-1.1.926-2 2.059-2h12.353c1.132 0 2.059.9 2.059 2v2zM6.44 10.15h1.732c.853 0 1.43.577 1.43 1.348 0 .77-.577 1.347-1.43 1.347h-.687V14H6.44v-3.85zm1.677.935h-.632v.825h.632c.248 0 .44-.193.44-.412 0-.22-.192-.413-.44-.413zM13.063 14h-2.75v-3.85h1.046v2.915h1.704V14zm.6 0v-3.85h1.045V14h-1.045zm3.57-1.182c0-.523-1.787-.248-1.787-1.595 0-.606.578-1.183 1.457-1.183.935 0 1.348.55 1.348.55l-.605.633s-.253-.303-.633-.303c-.247 0-.412.165-.412.33 0 .523 1.787.248 1.787 1.595 0 .688-.577 1.265-1.54 1.265-1.017 0-1.54-.66-1.54-.66l.605-.632s.33.412.825.412c.303 0 .496-.193.496-.412zm1.48-2.668h3.19v.935H20.83V14h-1.045v-2.915h-1.073v-.935z"
      />
    </defs>
    <use
      fill="currentColor"
      fillRule="evenodd"
      xlinkHref="#icons-file-plist_svg__a"
    />
  </svg>
);
